import { render } from "./TaskAdd.vue?vue&type=template&id=0faa5883&scoped=true"
import script from "./TaskAdd.vue?vue&type=script&lang=js"
export * from "./TaskAdd.vue?vue&type=script&lang=js"

import "./TaskAdd.vue?vue&type=style&index=0&id=0faa5883&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0faa5883"]])

export default __exports__